import * as tslib_1 from "tslib";
import fscreen from 'fscreen';
import get from 'lodash/get';
import { takeLatest, all, call, put, select, takeEvery, fork, race, take, } from 'redux-saga/effects';
import { loadDeviation, toggleCollectionPanel, showCollectionPanel, hideGroupsPanel, toggleGroupsPanel, showGroupsPanel, requestChangeViewMode, fullscreenExited, fullscreenEntered, initDeviationPage, enterZoomMode, exitZoomMode, } from './actions';
import { initializeThreadFromPapi } from '../../CommentThread/actionCreators';
import { normalize } from 'normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { putEntities } from '../../redux/entities/actions';
import { actions as collectionActions } from '../../CollectionPanel/redux';
import { getVisiblePanel, getIsTheaterForced, getIsFullscreenAllowed, getBiEventData, } from './selectors';
import { getIsLoggedIn, getViewMode } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import ddt from '@wix/da-ddt';
import { DeviationViewMode } from '../../publicSession/types';
import { setViewMode } from '../../publicSession/actions';
import { BiEventType, logger as biLogger } from '../../biLogger';
import { getBiEventTypeForViewChange } from './helpers';
import { setWatchingState } from '../../WatchButton/actionCreators';
import { exitDuperbrowse, shutdownDuperbrowse, } from '../../Duperbrowse/redux/actionCreators';
var fsLogger = ddt.createLogger('fullscreen');
function handleLoadDeviation(_a) {
    var _b, view, publicSession, eventComponent, deviationId, deviationResourceType, isDuperbrowse, event;
    var deviation = _a.payload.deviation;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getBiEventData, deviation)];
            case 1:
                _b = _c.sent(), view = _b.view, publicSession = _b.publicSession, eventComponent = _b.eventComponent, deviationId = _b.deviationId, deviationResourceType = _b.deviationResourceType, isDuperbrowse = _b.isDuperbrowse;
                event = {
                    evid: BiEventType.PAGEVIEW,
                    view: view,
                    component: eventComponent,
                    typeid: deviationResourceType,
                    itemid: deviationId,
                    is_duper: isDuperbrowse ? 1 : 0,
                };
                return [4 /*yield*/, call([biLogger, 'log'], publicSession, event)];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleInitDeviationPage(_a) {
    var entities, isAuthorWatched, author;
    var _b = _a.payload, deviation = _b.deviation, comments = _b.comments;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                entities = normalize(deviation, deviationSchema).entities;
                isAuthorWatched = get(deviation, 'extended.isWatchingAuthor', false);
                author = get(deviation, 'author.username', '');
                return [4 /*yield*/, all([
                        put(initializeThreadFromPapi(comments)),
                        put(setWatchingState(author, isAuthorWatched)),
                        put(putEntities({ entities: entities })),
                    ])];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleToggleCollectionPanel(_a) {
    var visible, isLoggedIn;
    var actionBar = _a.meta.actionBar;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getVisiblePanel, actionBar)];
            case 1:
                visible = _b.sent();
                if (!(visible === 'collection')) return [3 /*break*/, 3];
                return [4 /*yield*/, put(collectionActions.requestClose())];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getIsLoggedIn)];
            case 4:
                isLoggedIn = _b.sent();
                if (!!isLoggedIn) return [3 /*break*/, 6];
                return [4 /*yield*/, put(restrictLoggedOut())];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6: 
            // v2 panel always shows, there is no one-click unfave
            return [4 /*yield*/, all([put(hideGroupsPanel()), put(showCollectionPanel(actionBar))])];
            case 7:
                // v2 panel always shows, there is no one-click unfave
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleToggleGroups(_a) {
    var visible, isLoggedIn;
    var actionBar = _a.meta.actionBar;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getVisiblePanel, actionBar)];
            case 1:
                visible = _b.sent();
                if (!(visible === 'groups')) return [3 /*break*/, 3];
                return [4 /*yield*/, put(hideGroupsPanel())];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getIsLoggedIn)];
            case 4:
                isLoggedIn = _b.sent();
                if (!!isLoggedIn) return [3 /*break*/, 6];
                return [4 /*yield*/, put(restrictLoggedOut())];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, all([
                    put(collectionActions.requestClose()),
                    put(showGroupsPanel(actionBar)),
                ])];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleEnterFullscreen() {
    fsLogger.log('Requesting fullscreen');
    fscreen.requestFullscreen(document.documentElement);
}
function handleExitFullscreen() {
    fsLogger.log('Requesting exit fullscreen');
    fscreen.exitFullscreen();
}
function getNextViewMode(currentViewMode, requestedViewMode, deviation) {
    var isTheaterStateForced, normalModeIfAllowed, isFullscreenAllowed, nextViewMode;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsTheaterForced, deviation)];
            case 1:
                isTheaterStateForced = _a.sent();
                normalModeIfAllowed = isTheaterStateForced
                    ? DeviationViewMode.Theater
                    : DeviationViewMode.Normal;
                return [4 /*yield*/, select(getIsFullscreenAllowed)];
            case 2:
                isFullscreenAllowed = _a.sent();
                switch (currentViewMode) {
                    case DeviationViewMode.Fullscreen:
                        switch (requestedViewMode) {
                            case DeviationViewMode.Fullscreen:
                            case DeviationViewMode.Normal:
                                nextViewMode = normalModeIfAllowed;
                                break;
                            case DeviationViewMode.Theater:
                                nextViewMode = DeviationViewMode.Theater;
                                break;
                            default:
                        }
                        break;
                    case DeviationViewMode.Theater:
                        switch (requestedViewMode) {
                            case DeviationViewMode.Fullscreen:
                                if (isFullscreenAllowed) {
                                    nextViewMode = DeviationViewMode.Fullscreen;
                                }
                                break;
                            case DeviationViewMode.Theater:
                            case DeviationViewMode.Normal:
                                nextViewMode = normalModeIfAllowed;
                                break;
                            default:
                        }
                        break;
                    case DeviationViewMode.Normal:
                        switch (requestedViewMode) {
                            case DeviationViewMode.Fullscreen:
                                if (isFullscreenAllowed) {
                                    nextViewMode = DeviationViewMode.Fullscreen;
                                }
                                break;
                            case DeviationViewMode.Theater:
                                nextViewMode = DeviationViewMode.Theater;
                                break;
                            default:
                        }
                        break;
                    default:
                }
                return [2 /*return*/, nextViewMode];
        }
    });
}
function handleRequestChangeViewMode() {
    var _a, requestChange, fsExit, fsEnter, requestedViewMode, deviation, currentViewMode, nextViewMode, _b, view, publicSession, eventComponent, deviationId, event_1;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                // Because this waits in a while loop, we dont want it on the serverside
                if (typeof window === 'undefined') {
                    return [2 /*return*/];
                }
                _c.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, race({
                        requestChange: take(requestChangeViewMode),
                        fsExit: take(fullscreenExited),
                        fsEnter: take(fullscreenEntered),
                    })];
            case 2:
                _a = _c.sent(), requestChange = _a.requestChange, fsExit = _a.fsExit, fsEnter = _a.fsEnter;
                requestedViewMode = requestChange
                    ? requestChange.payload.viewMode
                    : fsExit
                        ? DeviationViewMode.Normal
                        : fsEnter
                            ? DeviationViewMode.Fullscreen
                            : undefined;
                deviation = get(requestChange || fsExit || fsEnter || {}, 'payload.deviation');
                // this should not happen(tm), but just in case
                if (!requestedViewMode) {
                    return [3 /*break*/, 1];
                }
                fsLogger.log('View mode change requested:', requestedViewMode);
                return [4 /*yield*/, select(getViewMode)];
            case 3:
                currentViewMode = _c.sent();
                return [4 /*yield*/, call(getNextViewMode, currentViewMode, requestedViewMode, deviation)];
            case 4:
                nextViewMode = _c.sent();
                fsLogger.log('Determined target view mode:', nextViewMode);
                // nothing changed, go back to waiting for events
                if (currentViewMode === nextViewMode) {
                    return [3 /*break*/, 1];
                }
                if (!(currentViewMode === DeviationViewMode.Fullscreen && !fsExit)) return [3 /*break*/, 6];
                fsLogger.log('Full screen exit sync start');
                return [4 /*yield*/, all([call(handleExitFullscreen), take(fullscreenExited)])];
            case 5:
                _c.sent();
                fsLogger.log('Full screen exit sync complete');
                return [3 /*break*/, 8];
            case 6:
                if (!(nextViewMode === DeviationViewMode.Fullscreen && !fsEnter)) return [3 /*break*/, 8];
                fsLogger.log('Full screen exit sync start');
                return [4 /*yield*/, all([call(handleEnterFullscreen), take(fullscreenEntered)])];
            case 7:
                _c.sent();
                fsLogger.log('Full screen enter sync complete');
                _c.label = 8;
            case 8:
                if (!(nextViewMode && deviation)) return [3 /*break*/, 11];
                fsLogger.log('Mode change ready', nextViewMode);
                return [4 /*yield*/, select(getBiEventData, deviation)];
            case 9:
                _b = _c.sent(), view = _b.view, publicSession = _b.publicSession, eventComponent = _b.eventComponent, deviationId = _b.deviationId;
                event_1 = {
                    evid: getBiEventTypeForViewChange(currentViewMode, nextViewMode),
                    view: view,
                    component: eventComponent,
                    deviationid: deviationId,
                    viewmode: nextViewMode,
                };
                return [4 /*yield*/, all([
                        put(setViewMode({ currentViewMode: currentViewMode, nextViewMode: nextViewMode })),
                        call([biLogger, 'log'], publicSession, event_1),
                    ])];
            case 10:
                _c.sent();
                _c.label = 11;
            case 11: return [3 /*break*/, 1];
            case 12: return [2 /*return*/];
        }
    });
}
function handleZoomChange(_a) {
    var _b, view, publicSession, eventComponent, deviationId, deviationResourceType, event;
    var deviation = _a.payload.deviation, type = _a.type;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getBiEventData, deviation)];
            case 1:
                _b = _c.sent(), view = _b.view, publicSession = _b.publicSession, eventComponent = _b.eventComponent, deviationId = _b.deviationId, deviationResourceType = _b.deviationResourceType;
                event = {
                    evid: BiEventType.ZOOM_MODE,
                    view: view,
                    component: eventComponent,
                    typeid: deviationResourceType,
                    deviationid: deviationId,
                    viewmode: type === enterZoomMode.toString() ? 'zoom' : 'regular',
                };
                return [4 /*yield*/, call([biLogger, 'log'], publicSession, event)];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleExitDuperbrowse() {
    if (fscreen.fullscreenElement) {
        fscreen.exitFullscreen();
    }
}
export default function deviationPageSaga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    fork(handleRequestChangeViewMode),
                    takeLatest(loadDeviation, handleLoadDeviation),
                    takeEvery(initDeviationPage, handleInitDeviationPage),
                    takeEvery(toggleCollectionPanel, handleToggleCollectionPanel),
                    takeEvery(toggleGroupsPanel, handleToggleGroups),
                    takeEvery([enterZoomMode, exitZoomMode], handleZoomChange),
                    takeEvery([exitDuperbrowse, shutdownDuperbrowse], handleExitDuperbrowse),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map